import LinkDetailsIcons from "components/LinkDetailsIcons";
import { getDomainName } from "core/Utils";
import React, { Component } from "react";
import endSession from "core/api/endSession/endSession";
import Cookies from "universal-cookie";
import Loading from "components/Loading";
const cookies = new Cookies();
const opened = "mdn-Menu-list-item mdn-Menu-list-item-search mdn-isActive";
const closed = "mdn-Menu-list-item mdn-Menu-list-item-search";
const logoutLink = process.env.REACT_APP_END_SESSION_REDIRECT ;
class HeaderMenu extends Component {
  container = React.createRef();

  state = {
    open: false,
    menuClass: closed,
    loading: false
  };
 

  handleButtonClick = () => {
    this.setState((state) => {
      return {
        open: !state.open,
        menuClass: this.state.menuClass === opened ? closed : opened,
      };
    });
  };

  handleClickOutside = (event) => {
    if (event.target.classList.contains("mdn-Link")) return;
    if (
      this.container.current &&
      !this.container.current.contains(event.target)
    ) {
      this.setState({
        open: false,
        menuClass: closed,
      });
    }
  };

  shiftTabPressed = (event) => {
    if (
      event.shiftKey &&
      event.keyCode === 9 &&
      event.target.id === "minhaClaroMovel"
    ) {
      this.closeMenu(event);
    }

    if (
      !event.shiftKey &&
      event.keyCode === 9 &&
      event.target.id === "minhaClaroSair"
    ) {
      this.closeMenu(event);
    }

    if (
      event.shiftKey &&
      event.keyCode === 9 &&
      event.target.id === "mdn-Header"
    ) {
      this.setState({
        open: false,
        menuClass: closed,
      });
    }
  };

  closeMenu = (event) => {
    if (
      this.container.current &&
      !this.container.current.contains(event.target)
    ) {
      this.setState({
        open: false,
        menuClass: closed,
      });
    }
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    document.addEventListener("keydown", this.shiftTabPressed, false);
  }
  logoutFn = async (ev) => {
      this.setState({
        loading: true,
      });
      await endSession();
      ev.preventDefault();
        cookies.remove("accesstoken", {
        domain: getDomainName(window.location.hostname),
      });
      
      document.location.href = logoutLink ;
     
      };
   
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    document.addEventListener("keydown", this.shiftTabPressed, false);
  }

  render() {
   
   
    return (
      <><Loading isLoading={this.state.loading} /><ul className="mdn-Menu-list mdn-resetPosition">
        <li className={this.state.menuClass} onClick={this.handleButtonClick}>
          <div className="mdn-Menu-list-item-link">
            <button
              className="mdn-Text mdn-Menu-list-anchor"
              id="mdn-Header"
              tabIndex="9"
            >
              <a
                className="mdn-Text"
                title="Menu"
                alt="selecione aqui o produto que deseja ser direcionado ou escolha para sair"
              >
                <span className="mdn-Menu-list-item-search-label">
                  {this.props.globalState.state.user &&
                  this.props.globalState.state.user.firstName
                    ? this.props.globalState.state.user.firstName
                    : "Cliente"}
                </span>

                <div className="mdn-Avatar mdn-Avatar--md avatar-margin cred-icon-menu ">
                  <i className="mdn-Avatar-icon mdn-Icon--md mdn-Icon-minha-claro"></i>
                </div>
              </a>
            </button>
          </div>
          <div className="mdn-Menu-subMenu mdn-Menu-subMenu-notificationsIn">
            <div className="mdn-Menu-subMenu mdn-Menu-subMenu--notifications cred-subMenuNotifications">
              <div className="cred-userMenu">
                <LinkDetailsIcons
                  links={[
                    {
                      target: "_blank",
                      link: "https://minhaclaro.claro.com.br/",
                      linkText: "Minha Claro Móvel",
                      content: "",
                      icon: "celular",
                      internal: false,
                      "data-gtm-event-category": "minha-claro:meu-perfil",
                      "data-gtm-event-action": "clique:menu-header",
                      "data-gtm-event-label": "minha-claro-movel",
                      itemId: "minhaClaroMovel",
                      tabIndex: "9",
                    },
                    {
                      target: "_blank",
                      link: "https://minhaclaroresidencial.claro.com.br/",
                      linkText: "Minha Claro Residencial",
                      content: "",
                      icon: "residencial",
                      internal: false,
                      "data-gtm-event-category": "minha-claro:meu-perfil",
                      "data-gtm-event-action": "clique:menu-header",
                      "data-gtm-event-label": "minha-claro-residencial",
                      itemId: "minhaClaroResidencial",
                      tabIndex: "10",
                    },
                    {
                      target: "_blank",
                      link: "https://www.clarotvmais.com.br/home-landing",
                      linkText: "Minha Claro TV (Claro TV+)",
                      content: "",
                      icon: "tv",
                      internal: false,
                      "data-gtm-event-category": "minha-claro:meu-perfil",
                      "data-gtm-event-action": "clique:menu-header",
                      "data-gtm-event-label": "minha-claro-tv",
                      itemId: "minhaClaroTV",
                      tabIndex: "11",
                    },
                    {
                      target: "",
                      //  link: logoutLink,
                      onClick: this.logoutFn,
                      onBlur: this.shiftTabPressed,
                      linkText: "Sair",
                      content: "",
                      icon: "sair",
                      internal: false,
                      "data-gtm-event-category": "minha-claro:meu-perfil",
                      "data-gtm-event-action": "clique:menu-header",
                      "data-gtm-event-label": "sair",
                      itemId: "minhaClaroSair",
                      tabIndex: "12",
                    },
                  ]} />
              </div>
            </div>
          </div>
        </li>
      </ul></>
    );
  }
}

export default HeaderMenu;
